import i18next from 'i18next';

import { placesBinar } from './areas.types';
import { Binary_Position_Branch, TreeAccount } from '../../generated/mlmbox/types/account';
import { Invoice_PreviewResponse_Item } from '../../generated/mlmbox/types/product';

export function getBranch(leftBranch: Binary_Position_Branch | undefined, rightBranch: Binary_Position_Branch | undefined): number {
    let result = 1;

    if (leftBranch && !rightBranch) return (result = 2);
    if (rightBranch && !leftBranch) return (result = 1);
    if (rightBranch && leftBranch) {
        if (rightBranch.teamQuantity < leftBranch.teamQuantity) return (result = 2);
        if (rightBranch.teamQuantity > leftBranch.teamQuantity) return (result = 1);
        if (rightBranch.teamQuantity === leftBranch.teamQuantity) return (result = 1);
    }
    return result;
}

export function getInfoForBinar(matrix: TreeAccount) {
    if (!matrix) return;
    if (matrix.activatedQuantity > 0) return placesBinar.ACTIVE;
    if (matrix.bookingQuantity === 0 && matrix.activatedQuantity === 0) return placesBinar.ONE;
    if (matrix.bookingQuantity === 7 || matrix.activatedQuantity === 7) return placesBinar.ALL;
    if ((matrix.bookingQuantity < 3 && matrix.bookingQuantity >= 1) || (matrix.activatedQuantity < 3 && matrix.activatedQuantity >= 1))
        return placesBinar.THREE;
    if ((matrix.bookingQuantity >= 3 && matrix.bookingQuantity < 7) || (matrix.activatedQuantity >= 3 && matrix.activatedQuantity < 7))
        return placesBinar.SEVEN;
    // return placesBinar.ALL;
}

export function getInfoForBinarS(matrix: TreeAccount) {
    if (!matrix) return;

    if (matrix.bookingQuantity === 0 && matrix.activatedQuantity === 0) return placesBinar.ONE;
    if (matrix.bookingQuantity === 7 || matrix.activatedQuantity === 7) return placesBinar.ALL;
    if ((matrix.bookingQuantity < 3 && matrix.bookingQuantity >= 1) || (matrix.activatedQuantity < 3 && matrix.activatedQuantity >= 1))
        return placesBinar.THREE;
    if ((matrix.bookingQuantity >= 3 && matrix.bookingQuantity < 7) || (matrix.activatedQuantity >= 3 && matrix.activatedQuantity < 7))
        return placesBinar.SEVEN;
    // return placesBinar.ALL;
}

export function getTitleForBinar(matrix: TreeAccount): string {
    const typeBinar = getInfoForBinar(matrix);
    let result = '';
    if (matrix.activatedQuantity > 0) return '';
    switch (typeBinar) {
        case placesBinar.ONE:
            if (matrix.treeId === 16) result = i18next.t('bin.work_not_have');
            if (matrix.treeId === 17) result = i18next.t('bin.buisines_not_have');
            break;

        case placesBinar.THREE:
            if (matrix.treeId === 16) result = i18next.t('bin.work_how_one', { quantity: 1 });
            if (matrix.treeId === 17) result = i18next.t('bin.buisines_how_one', { quantity: 1 });
            break;

        case placesBinar.SEVEN:
            if (matrix.treeId === 16) result = i18next.t('bin.work_how_few', { quantity: 3 });
            if (matrix.treeId === 17) result = i18next.t('bin.buisines_how_few', { quantity: 3 });
            break;

        case placesBinar.ALL:
            if (matrix.treeId === 16) result = i18next.t('bin.work_how_many', { quantity: 7 });
            if (matrix.treeId === 17) result = i18next.t('bin.buisines_how_many', { quantity: 7 });
            break;
    }
    return result;
}

export function getAmountForBinar(num: number): number {
    if (num === 1) return 25;
    if (num === 2) return 800;

    return 1;
}

function getNumberForm(count: number): string {
    if (count === 1) {
        return i18next.t('matrix.reserv.modals.ready.few');
    } else if (count > 1 && count < 5) {
        return i18next.t('matrix.reserv.modals.ready.many');
    } else {
        return i18next.t('matrix.reserv.modals.ready.many');
    }
}

export function getPositions(list: Invoice_PreviewResponse_Item[]): string {
    let result = [];
    let resultString = '';
    let B25: Invoice_PreviewResponse_Item | null = null;
    let B800: Invoice_PreviewResponse_Item | null = null;

    for (let i = 0; i < list.length; i++) {
        if (list[i].treeId !== 16 && list[i].treeId !== 17) {
            result.push(list[i].treeId);
        }
        if (list[i].treeId === 16) {
            B25 = list[i];
        }

        if (list[i].treeId === 17) {
            B800 = list[i];
        }
    }

    if (B25) {
        if (result.length > 0 || B800) {
            resultString += `${B25.quantity} ${getNumberForm(B25.quantity)} B25, `;
        } else {
            resultString += `${B25.quantity} ${getNumberForm(B25.quantity)} B25`;
        }
    }

    if (B800) {
        if (result.length > 0) {
            resultString += `${B800.quantity} ${getNumberForm(B800.quantity)} B800, `;
        } else {
            resultString += `${B800.quantity} ${getNumberForm(B800.quantity)} B800`;
        }
    }

    if (result.length === 1) resultString += `P${result[0]}`;
    if (result.length > 0 && result.length !== 1) {
        const min = Math.min(...result);
        const max = Math.max(...result);

        resultString += `P${min}-P${max}`;
    }
    return resultString;
}
